import { render, staticRenderFns } from "./f05.vue?vue&type=template&id=62f39ab7"
import script from "./f05.vue?vue&type=script&lang=js"
export * from "./f05.vue?vue&type=script&lang=js"
import style0 from "./f05.vue?vue&type=style&index=0&id=62f39ab7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports